import { UnidadeMedidaRepository } from "../repository/unidade_medida_repository";

export class UnidadeMedidaService {
	constructor() {
		this.unidadeMedidaRepository = new UnidadeMedidaRepository();
	}

	async get() {
		const unidadeMedidaData = await this.unidadeMedidaRepository.get();
		return unidadeMedidaData;
	}

	async getAll() {
		const unidadeMedidaData = await this.unidadeMedidaRepository.get();
		return { data: unidadeMedidaData };
	}

	async getByCultivo() {
		const unidadeMedidaData = await this.unidadeMedidaRepository.get({ cultivo: true });
		return unidadeMedidaData;
	}

	async getAllByCultivo() {
		const unidadeMedidaData = await this.unidadeMedidaRepository.get({ cultivo: true });
		return { data: unidadeMedidaData };
	}
}

export default UnidadeMedidaService;
